export default __webpack_public_path__ + "static/media/copy-button-icon.6b93cafe.svg";